import type { IColumnInfo } from '@dbl/core/dataSource';
import { DragState } from '@/pages/datalab/components/SortableDrag/typeDefine';
import type { INumberPackage } from '@dbl/services/numberPackage';
import React from 'react';
import {connect, useSelector} from 'umi';
import type { IGetTableInfoDto } from '@dbl/services/dataSource';
import { CustomColumn } from '@/pages/datalab/pages/Multidimensional/Analysis/interface';
import { namespace } from '../../model';
// import HeaderData from '../HeaderData';
import DataSourceRelation from '../HeaderData/dataSourceRelation';
import { ITableJoinRelation } from '../HeaderData/interface';
import PacketSelect from '../HeaderData/packetSelect';
import TableFieldList from '../TableFieldList';

export default connect((state: any) => {
  const {
    dataTables,
    dataTableJoinRelations,
    isOpenSelfJoin,
    customColumns,
    columnFilters = [],
    columnCompares = [],
    columnMetrics = [],
    columnDimensions = [],
    columnX = [],
    columnShowDimensions = [],
    columnRawColumns = [],
    userPackages = [],
    autoSelectTable = false,
    chartType = 'Table',
    dragState = {},
  }: {
    tableWidth: number;
    dataTableJoinRelations: ITableJoinRelation[];
    isOpenSelfJoin: boolean;
    customColumns: CustomColumn[];
    dataTables: IGetTableInfoDto[];
    columnFilters: IColumnInfo[];
    columnCompares: IColumnInfo[];
    columnMetrics: IColumnInfo[];
    columnDimensions: IColumnInfo[];
    columnX: IColumnInfo[];
    columnShowDimensions: IColumnInfo[];
    columnRawColumns: IColumnInfo[];
    userPackages: INumberPackage[];
    dragState: DragState;
    autoSelectTable: boolean;
    chartType: string;
  } = state[namespace];
  return {
    dataTables,
    dataTableJoinRelations,
    isOpenSelfJoin,
    customColumns,
    columnFilters,
    columnCompares,
    columnMetrics,
    columnDimensions,
    columnX,
    columnShowDimensions,
    columnRawColumns,
    userPackages,
    autoSelectTable,
    chartType,
    dragState
  };
})(DataSource);

function DataSource(props: any) {
  const { gameCode } = useSelector((state) => ({gameCode: state.datalab.gameCode}));
  
  return (
    <>
      <PacketSelect {...props} gameCode={gameCode} namespace={namespace} />
      <DataSourceRelation {...props} gameCode={gameCode} namespace={namespace} showSelfJoin isHaveChart={true} isDragDrop={true}/>
      <TableFieldList {...props} namespace={namespace} isShowCustomColumns={true} />
    </>
  );
}
